/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { FilterAgent } from '@bingads-webui/filter-agent';
import { updateGridQuery } from '@bingads-webui-campaign/summary-grid-helper';

export function initializeFilterAgent({
  filterConfig,
  gridView,
  tabView,
  toolbar,
}) {
  tabView.filterAgent = new FilterAgent(_.extend(filterConfig, {
    toolbarView: toolbar,
  }));

  gridView.listenTo(tabView.filterAgent, 'filter-state-changed', ({ filter } = {}) => {
    updateGridQuery(gridView, filter);
  });

  gridView.listenTo(tabView.filterAgent, 'filter-ui-change', (state) => {
    if (state.showFilterBar) {
      tabView._initialRenderFilter(tabView.searchPropertyName);
    }
  });
}
